import initializeAppConfig from '~/app/config'
import withHttp from '~/app/providers/http'
import withMetaData from '~/app/providers/metadata'
import Router from '~/app/providers/router'
import withUI from '~/app/providers/ui'
import combineComponents from '~/app/utils'

function App() {
  initializeAppConfig()
  const providers = [withUI, withHttp, withMetaData]
  const AppProvider = combineComponents(Router, providers)

  return <AppProvider />
}

export default App
